/** TanStack Router paths for diary entry flows (kept here so services avoid importing route modules). */
export const diaryNewTrackerEntryPagePath =
    "/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex" as const;

/** Foot photo capture nested under a tracker entry page. */
export const diaryFootPhotosUploadPath =
    "/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload" as const;

export const diaryFootPhotosUploadMessagePath =
    "/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/message" as const;

export const diaryFootPhotosCameraPath =
    "/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/camera" as const;

export const diaryFootPhotosInstructionsPath =
    "/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions/$angle/$side" as const;

/** Patient diary home routes. */
export const diaryHomeToDoPath = "/diaries/$diaryId/home/to-do" as const;
export const diaryHomeResultsPath = "/diaries/$diaryId/home/results" as const;
export const diaryHomeEditPath = "/diaries/$diaryId/home/edit" as const;

export interface DiaryFootPhotosRouteParams {
    diaryId: string;
    trackerId: string;
    entryId: string;
    pageIndex: string;
}
